<template>
  <div class="lb">
    <div>
      <div class="subhead">
        <div class="subhead_item">
          <div class="tem13_icon_subhead"></div>
          <div class="subhead-text">
            <p class="subhead-value">
              {{ numformat(defaultdata[0].value4, 2) }}
            </p>
            <p class="subhead-title">{{ defaultdata[0].value5 }}</p>
          </div>
        </div>
        <div class="subhead_item">
          <div class="tem13_icon_subhead"></div>
          <div class="subhead-text">
            <p class="subhead-value">
              {{ numformat(defaultdata[0].value6, 2) }}
            </p>
            <p class="subhead-title">{{ defaultdata[0].value7 }}</p>
          </div>
        </div>
        <div class="subhead_item">
          <div class="tem13_icon_subhead"></div>
          <div class="subhead-text">
            <p class="subhead-value">
              {{ numformat(defaultdata[0].value8, 2) }}
            </p>
            <p class="subhead-title">{{ defaultdata[0].value9 }}</p>
          </div>
        </div>
      </div>
      <div
        class="text-area"
        ref="content"
        @mouseenter="mouseenterEvent()"
        @mouseleave="mouseleaveEvent()"
      >
        <div class="list-content" ref="scroll1">
          <div class="lt-left-item" v-for="(item, i) in scopelist" :key="i">
            <div class="lt-left-head">
              <p>TOP.{{ i + 1 }}</p>
              <div>
                <p>{{ item.value1 }}</p>
              </div>
              <p class="head-value">
                {{ item.value2 }}{{ defaultdata[0].value3 }}
              </p>
            </div>
            <div class="bottom-area">
              <div
                class="bottom-active"
                :title="`${item.value2}${defaultdata[0].value3}`"
                :style="{
                  width: (+item.value2 / +scopelist[0].value2) * 100 + '%',
                }"
              >
                <div class="bottom-border"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-content" ref="scroll2" v-if="scopelist.length > 4">
          <div class="lt-left-item" v-for="(item, i) in scopelist" :key="i">
            <div class="lt-left-head">
              <p>TOP.{{ i + 1 }}</p>
              <div>
                <p>{{ item.value1 }}</p>
              </div>
              <p class="head-value">
                {{ item.value }}{{ defaultdata[0].value3 }}
              </p>
            </div>
            <div class="bottom-area">
              <div
                class="bottom-active"
                :title="`${item.value2}${defaultdata[0].value3}`"
                :style="{
                  width: (+item.value2 / +scopelist[0].value2) * 100 + '%',
                }"
              >
                <div class="bottom-border"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope106",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "循环滚动水平条形图-scope106",
      timer: null,
      defaultdata: [
        {
          value1: "系列一",
          value2: "1000",
          value3: "万元",
          value4: "16",
          value5: "热搜数量",
          value6: "16",
          value7: "热搜数量",
          value8: "16",
          value9: "热搜数量2",
        },
        {
          value1: "系列二",
          value2: "900",
        },
        {
          value1: "系列三",
          value2: "800",
        },
        {
          value1: "系列四",
          value2: "700",
        },
        {
          value1: "系列五",
          value2: "600",
        },
        {
          value1: "系列六",
          value2: "500",
        },
        {
          value1: "系列7",
          value2: "400",
        },
        {
          value1: "系列8",
          value2: "300",
        },
        {
          value1: "系列9",
          value2: "200",
        },
        {
          value1: "系列十",
          value2: "100",
        },
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "数值", key: "value2" },
        { name: "单位", key: "value3" },
        { name: "标题一", key: "value4" },
        { name: "标题一内容", key: "value5" },
        { name: "标题二", key: "value6" },
        { name: "标题二内容", key: "value7" },
        { name: "标题三", key: "value8" },
        { name: "标题三内容", key: "value9" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      scopelist: [],
      iscontact: false,
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n.filter((item) => item && item[this.valueMap[0].key])
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      console.log('___deffff', n)
      this.Drawdata();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
    rollUp(t) {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (ulf1.offsetHeight > 200) {
        box.scrollTop = 0;
        this.timer = window.setInterval(this.rollStart, t);
      } else if (ulf1.offsetHeight == 0) {
        setTimeout(() => {
          this.rollUp(150);
        }, 200);
      }
    },
    rollStart() {
      const ulf1 = this.$refs.scroll1;
      const box = this.$refs.content;
      if (box.scrollTop >= ulf1.scrollHeight) {
        box.scrollTop = 0;
      } else {
        box.scrollTop += 2;
      }
    },
    mouseenterEvent() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    mouseleaveEvent(t) {
      if (!this.timer) {
        this.timer = setInterval(this.rollStart, 150);
      }
    },
    Drawdata() {
      let linedata = JSON.parse(JSON.stringify(this.defaultdata));
      linedata = linedata.sort((a, b) => +b.value3 - +a.value3).slice(0, 10);
      this.scopelist = linedata;
    },
  },
  created() {},
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.setData();
    this.Drawdata(); //需要刷新的数据
    this.$nextTick(() => {
      this.rollUp(150);
    });
  },
};
</script>

<style scoped lang="scss">
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  position: relative;
  padding: 10px 0;
}

.subhead {
  width: 435px;
  height: 70px;
  // margin: 0 0 10px;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  .subhead_item {
    flex: 1;
    display: flex;
    align-items: center;
    .tem13_icon_subhead {
      width: 55px;
      height: 49px;
      background: url("../../assets/temimg13/tem13_icon_subhead.png") no-repeat;
      background-size: 100% 100%;
    }
    .subhead-text {
      margin-left: 6px;
      .subhead-value {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 19px;
        color: #f5f9ff;
        line-height: 15px;
        white-space: nowrap;
      }
      .subhead-title {
        margin-top: 6px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #c8d2d9;
        line-height: 15px;
      }
    }
  }
}

.bottom-area {
  margin-top: 8px;
  width: 100%;
  background: #1f2a30;
  border-radius: 10px;
  height: 10px;
  position: relative;

  .bottom-active {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .bottom-border {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    animation: name duration timing-function delay iteration-count direction
      fill-mode;
    background: linear-gradient(
      to right,
      rgba(10, 114, 252, 0.6),
      rgba(10, 114, 252, 1)
    );
    animation: borderactive 7.5s infinite linear;
  }
}

@keyframes borderactive {
  0% {
    width: 0%;
  }

  33% {
    width: 100%;
  }

  100% {
    width: 100%;
  }
}

.lt-left-head {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #bcc1ca;
  width: 100%;

  div {
    display: inline-block;
    max-width: 160px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  > p {
    &:first-child {
      width: 50px;
    }

    & + p {
      margin-left: 20px;
      margin-right: 8px;
    }
  }

  .head-value {
    margin-left: auto;
    margin-right: 8px;
    color: #faec00;
  }
}

.text-area {
  pointer-events: auto;
  width: 100%;
  max-height: 150px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0;
  }
}
</style>
